module.exports = __webpack_public_path__ + "static/img/share-txt.9c90438.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/Play/img/result-2/share-txt.png
// module id = 182
// module chunks = 0